document.addEventListener("DOMContentLoaded", () => {
    const accordionItems = document.querySelectorAll(".accordion .acc-item");

    accordionItems.forEach((item) => {
        item.addEventListener("click", () => {
            const isExpanded = item.getAttribute("aria-expanded") === "true";

            // Close all accordion items
            accordionItems.forEach((el) => {
                el.setAttribute("aria-expanded", "false");
                
            });

            // Toggle the clicked item's state
            if (!isExpanded) {
                item.setAttribute("aria-expanded", "true");
            }
        });
    });
});
